import React, { Component } from 'react';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import ru from 'date-fns/locale/ru';
import { ENotificationType } from '../../repositories/notification-center/entities/notification/NotificationForDesktopSchema';
import { trackingNotificationClick } from '../NotificationCenter/tracking';
import { TSection } from '../../repositories/frontend-header/entities/entities';

interface IControlModalProps {
  id: number;
  isRead: boolean;
  section?: TSection;
  mediaUrl?: string | null;
  notificationType: ENotificationType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any | null;
  text: string;
  title: string;
  updateTimestamp: number;
  updateDatetime: string;
  url: string;
  withWebPush?: boolean | null;
  markAsRead(id: number): void;
}

export interface ITrackingExtra {
  pushType: ENotificationType;
  pushSubType?: string;
}

export class Notification extends Component<IControlModalProps> {
  private handleNotificationClick = (
    id: number,
    notificationType: ENotificationType,
    withWebPush: boolean,
    // payload: any указать в INotificationForDesktopSchema
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any,
  ) => {
    const { markAsRead } = this.props;
    const extra: ITrackingExtra = {
      pushType: notificationType,
      pushSubType: payload?.pushSubType,
    };

    trackingNotificationClick(withWebPush, extra);
    markAsRead(id);
  };

  private formatDate = (date: string) => {
    return formatDistanceToNow(new Date(date), { addSuffix: true, locale: ru });
  };

  public render() {
    const {
      id,
      text,
      title,
      url,
      isRead,
      updateDatetime,
      notificationType,
      withWebPush,
      payload,
      mediaUrl,
    } = this.props;

    return (
      <a key={id} className="c-notification-center__link" href={url} target="_blank" rel="noopener noreferrer">
        <div
          {...mergeStyles(
            'c-notification-center__block c-notification-center__block--notification',
            !isRead && 'unread',
          )}
          onClick={() => {
            this.handleNotificationClick(id, notificationType, Boolean(withWebPush), payload);
          }}
        >
          <div className="c-notification-center__content">
            <p className="c-notification-center__title">{title}</p>
            <p className="c-notification-center__description">{text}</p>
            <p className="c-notification-center__time">{this.formatDate(updateDatetime)}</p>
          </div>
          {mediaUrl && <img className="c-notification-center__image" src={mediaUrl} />}
        </div>
      </a>
    );
  }
}
